export default {
    NONE: 'none',
    ATTACHED: 'attached',
    BASEMENT: 'basement',
    BUILT_IN: 'built-in',
    CARPORT: 'carport',
    DETACHED: 'detached',
};
